import { Col as ColAntd, Typography as TypographyAntd } from 'antd';
import styled from 'styled-components';

export const MiniCard = styled(ColAntd)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  border: 2px solid #c4c4c4;
  box-sizing: border-box;
  border-radius: 4px;
  width: 110px;
  height: 60px;

  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  line-height: 20px;
  font-style: normal;

  margin: 10px;
  padding-top: 5px;

  .title {
    color: #74aa49;
    font-weight: normal;
    padding-bottom: 8px;
  }
  .value {
    color: #676a6c;
    font-weight: bold;
  }
`;

export const Title = styled(TypographyAntd.Title)`
  font-size: 14px !important;
  color: #74aa49 !important;
  font-weight: normal !important;
  padding-bottom: 5px !important;
`;

export const SubTitle = styled(TypographyAntd.Text)`
  padding: 8px;
  font-size: 14px !important;
  color: #676a6c !important;
  font-weight: bold !important;
`;
